// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"ecf52a87","815":"f5c124cd"}[chunkId] + ".chunk.js";
};